import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Field } from 'formik';
import { AutoFormattedMessage } from '@pcid/string-utils';
import { minimumScore } from '@pcid/validate-password';

const strengthMessages = ['weak', 'weak', 'good', 'strong', 'strong'];

const generateTip = (tip) => ({
	id: `passwordStrength.tip.${tip}`,
	values: {
		bold: <strong><AutoFormattedMessage id={`passwordStrength.tip.${tip}.bold`} /></strong>,
	},
});

export const PasswordStrengthLayout = ({ password, score, tip, className, disabled }) => (
	<div
		className={classNames([
			'password-strength',
			password && score < minimumScore && 'password-strength--error',
			disabled && 'password-strength--disabled',
			className,
		])}
		aria-live="polite"
	>
		<div className="password-strength__meter">
			<span className="password-strength__label">
				<AutoFormattedMessage id="passwordStrength.label" />
			</span>
			<i
				className={classNames(
					'password-strength__bar',
					password && `password-strength__bar--${score}`
				)}
			/>
			<span className="password-strength__text">
				{ password && <AutoFormattedMessage id={`passwordStrength.barText.${strengthMessages[score]}`} /> }
			</span>
		</div>
		<div className="password-strength__tip">
			<AutoFormattedMessage {...(typeof tip === 'string' ? { id: tip } : tip)} />
		</div>
		{ score < 2 && (
			<ul className="password-strength__requirement-list">
				{
					['strength', 'length'].map((id) => (
						<li key={id} className="password-strength__requirement">
							<AutoFormattedMessage id={`passwordStrength.requirement.${id}`} />
						</li>
					))
				}
			</ul>
		) }
	</div>
);

PasswordStrengthLayout.propTypes = {
	password: PropTypes.string.isRequired,
	score: PropTypes.number.isRequired,
	tip: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
	]).isRequired,
	className: PropTypes.string,
	disabled: PropTypes.bool,
};

const PasswordStrength = (props) => (
	<Field
		name="passwordStrength"
		render={({ field: { value: { policyScore = 0, integrity } = {} } }) => (
			<PasswordStrengthLayout
				{...props}
				score={policyScore}
				tip={generateTip(integrity || 'default')}
			/>
		)}
	/>
);

export default PasswordStrength;
